/**
 * brand-reveal.js — subtle scroll/load reveal.
 *
 * Principles:
 *  - Progressive enhancement: nothing is hidden unless this script runs.
 *  - Above-the-fold content is never hidden (no blank screen, no wait-for-JS).
 *  - Only opacity + transform animate (compositor-only, no layout shift).
 *  - Reveals once per element, then stops observing.
 *  - Respects prefers-reduced-motion.
 *  - Groups related content into units with a short, capped stagger.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;

  // Containers whose children (or the container itself) form reveal units.
  var GROUP_SELECTORS = [
    '.brand-section__head',
    '.brand-grid',
    '.collection-grid__list',
    '.featured-spotlight__grid',
    '.editorial-feature__grid',
    '.faq__list',
    '.section-cta__inner',
    '.trust-bar__list',
    '.product-grid',
    '.resource-list',
    'footer .footer__blocks > *',
    'footer [class*="footer-block"]'
  ];

  var STAGGER_MS = 70;
  var STAGGER_CAP = 6;

  function run() {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var seen = new Set();

    GROUP_SELECTORS.forEach(function (sel) {
      var groups;
      try { groups = document.querySelectorAll(sel); } catch (e) { return; }
      groups.forEach(function (group) {
        var kids = [];
        for (var n = 0; n < group.children.length; n++) {
          if (group.children[n].nodeType === 1) kids.push(group.children[n]);
        }
        var units = (kids.length > 1 && kids.length <= 14) ? kids : [group];

        units.forEach(function (el, idx) {
          if (seen.has(el)) return;
          seen.add(el);

          var rect = el.getBoundingClientRect();
          var aboveFold = rect.top < vh * 0.9 && rect.bottom > 0;
          if (aboveFold) return; // leave visible, no animation

          el.classList.add('reveal');
          var delay = Math.min(idx, STAGGER_CAP) * STAGGER_MS;
          if (delay) el.style.setProperty('--reveal-delay', String(delay));
          io.observe(el);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
